import React, { useState, useEffect } from "react";
import { Container, Grid, Typography } from "@mui/material";
import api from "../../services/api";
import { useAppConfig } from "../../context/AppConfigContext";
import BookingForm from "./BookingForm";
import SessionCard from "./SessionCard"; // ✅ Import the reusable card

const DecoratingBookingPage = () => {
  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    numSeats: 1,
    notes: "",
  });

  const { config } = useAppConfig();
  const pricePerPerson = config?.decoratingClass?.pricePerPerson || 85;

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const res = await api.get("/classes/sessions/upcoming");
        setSessions(res.data);
      } catch (err) {
        console.error("Failed to fetch sessions", err);
      }
    };

    fetchSessions();
  }, []);

  return (
    <Container sx={{ py: 6 }}>
      {!selectedSession ? (
        <>
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Cake Decorating Classes
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Choose an available session below to book your spot.
          </Typography>

          <Grid container spacing={3}>
            {sessions.map((session) => (
              <Grid item xs={12} md={6} key={session._id}>
                <SessionCard
                  session={session}
                  onSelect={setSelectedSession}
                  pricePerPerson={pricePerPerson}
                />
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <BookingForm
          selectedSession={selectedSession}
          form={form}
          setForm={setForm}
          pricePerPerson={pricePerPerson}
        />
      )}
    </Container>
  );
};

export default DecoratingBookingPage;
